$(document).ready(() => {



    $('.btn-favorite-expert').on('click', function () {
        $.ajax({
            url: $(this).data('url'),
            type: "post",
            processData: true,
            dataType: 'json',
            data: {expert_profile: $(this).data('expert')},
            statusCode:{
                200: (res) => $(this).toggleClass('favorited'),
                400: (res) => console.log(res.responseJSON.error)
            }
        });
    });

    //Categories
    var maxChecks = 1;

    if ($('#membership_premium').is(':checked')) {
        //Add max categories to 3 if premium selected
        $('#max-categories').text('3 categories');
        maxChecks = 3;
        //Add class for publish form if 'premium' selected
        $('#form-publish').addClass('premium');
    }
    else if($('#membership_free').is(':checked')) {
        //Add max categories to 3 if free selected
        $('#max-categories').text('1 category');
        maxChecks = 1;
    }

    $('input[name="membership_type"]').on('change', function (){
        if ($('#membership_premium').is(':checked')) {
            //Add max categories to 3 if premium selected
            $('#max-categories').text('3 categories');

            maxChecks = 3;
            //Add class for publish form if 'premium' selected
            $('#form-publish').addClass('premium');
        }
        else if($('#membership_free').is(':checked')) {
            //Add max categories to 3 if free selected
            
            $('#max-categories').text('1 category');
            maxChecks = 1;
        }
        //reset selected categories
        $('#form-categories .category-container').removeClass('active');
        $('#form-categories .category-container .cbtn-check').removeClass('active');
        $(".pf_exp_category").prop("checked", false);
        $('#pf_exp_category_total').text(0);
    });

    // $('#form-categories .cbtn-radio-group .cbtn-check').on('click', function (e) {
    //     e.preventDefault();
    //     let $cbx = $(this).find('input[type=checkbox]');
    //     let checkedChecks = document.querySelectorAll(".pf_exp_category:checked");
    //     // Limit categories checkboxes
    //     if (checkedChecks.length < maxChecks) {
    //         if($cbx.attr('disabled') === undefined){
    //             $(this).closest('.category-container').toggleClass('active');
    //             $(this).toggleClass('active');
    //             $(this).find('input').prop("checked", !$(this).find('input').prop("checked"));
    //         }
    //     } else if (checkedChecks.length >= maxChecks) {
    //         if($cbx.attr('disabled') === undefined){
    //             $(this).closest('.category-container').removeClass('active');
    //             $(this).removeClass('active');
    //             $(this).find('input').prop("checked", false);
    //         }
    //     }

    //     //Update categories selected number
    //     $('#pf_exp_category_total').text($(".pf_exp_category:checked").length);

    // });

    $('.proceed-btn').click(function() {

        // check experience
        let experiences = document.querySelectorAll('input[name=experience_id]');
        if(experiences.length) removeError($('#experience-section .form-error'));
        else{
            $('button[data-target="#collapseFour"][aria-expanded=false]').trigger('click');
            setTimeout(() => showError($('#experience-section .form-error'), $('#experience-section')), 500);
            return false;
        }

        // check categories
        let categories = $("#form-categories input[type=checkbox]:checked");
        if(categories.length) removeError($('#form-categories .form-error'));
        else{
            showError($('#form-categories .form-error'), $('#form-categories'));
            return false;
        }

        // check skills
        let skills = $('select[name="skills[]"]').val();
        if(skills.length) removeError($('#form-skills .form-error'));
        else{
            showError($('#form-skills .form-error'), $('#form-skills'));
            return false;
        }

        // check overview
        let overview = $('textarea[name="overview"]').val();
        if(overview.length) removeError($('#form-overview .form-error'));
        else{
            $('button[data-target="#collapseOne"][aria-expanded=false]').trigger('click');
            setTimeout(() => showError($('#form-overview .form-error'), $('#form-overview')));
            return false;
        }

        $('#form-categories').trigger('submit');
        $('#form-skills').trigger('submit');
        $('#form-overview').trigger('submit');

    });

    let removeError = (error) => {
        error.removeClass('active');
    };

    let showError = (error, scroll) => {
        error.addClass('active');
        $('html, body').animate({
            scrollTop: scroll.offset().top
        }, 2000);
    };

    $('.show-long-description').on('click', function () {
        $(this).closest('.category-description').hide();
        $(this).closest('.category-description').siblings('.category-long-description').show();
    });

    $('.expert-menu-icon').on('click', function () {
        $(this).siblings('.favorite-container').toggleClass('active');
    });

});
